import React from 'react';
import { Question } from "@/types/test";
import { getValidationErrors } from "../utils/questionValidation";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { AlertCircle, CheckCircle2 } from "lucide-react";
import { Badge } from "@/components/ui/badge";

interface ValidationSummaryCardProps {
  question: Question;
  questionNumber: number;
  isValid: boolean;
}

export const ValidationSummaryCard: React.FC<ValidationSummaryCardProps> = ({
  question,
  questionNumber,
  isValid
}) => {
  const errors = getValidationErrors(question);

  if (isValid) {
    return (
      <Card className="border-green-200 dark:border-green-800 bg-green-50 dark:bg-green-950/20">
        <CardContent className="pt-6">
          <div className="flex items-center gap-2 text-green-700 dark:text-green-400">
            <CheckCircle2 className="h-4 w-4" />
            <span className="text-sm font-medium">Question {questionNumber} is complete and ready!</span>
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className="border-amber-200 dark:border-amber-800 bg-amber-50 dark:bg-amber-950/20">
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center gap-2 text-amber-700 dark:text-amber-400 text-sm">
          <AlertCircle className="h-4 w-4" />
          Question {questionNumber} needs attention
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-2">
        <p className="text-xs text-amber-600 dark:text-amber-300 mb-3">
          Complete the following fields to make this question ready:
        </p>
        <div className="space-y-1">
          {errors.map((error, index) => (
            <div key={index} className="flex items-center gap-2">
              <div className="w-1.5 h-1.5 bg-amber-500 rounded-full flex-shrink-0" />
              <span className="text-xs text-amber-700 dark:text-amber-300">{error}</span>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};